import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const NotFound = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        backgroundColor: "#ffffff", // --color-bg
      }}
    >
      <Box
        sx={{
          maxWidth: 640,
          textAlign: "center",
        }}
      >
        {/* 404 */}
        <Typography
          sx={{
            fontSize: { xs: 96, md: 140 },
            fontWeight: 600,
            letterSpacing: "-4px",
            color: "#212121", // --color-primary-dark
            opacity: 0.12,
            lineHeight: 1,
          }}
        >
          404
        </Typography>

        {/* Title */}
        <Typography
          variant="h4"
          sx={{
            mt: 2,
            mb: 1,
            fontWeight: 500,
            color: "#1c1c1c", // --color-text-primary
          }}
        >
          This Space Doesn’t Exist
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: 16,
            lineHeight: 1.7,
            color: "#6b6b6b", // --color-text-muted
            mb: 4,
          }}
        >
          The page you’re looking for is no longer available or was never part
          of our portfolio. Let us guide you back to exceptional properties and
          trusted real estate experiences.
        </Typography>

        {/* Actions */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
        >
          {/* Home */}
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            sx={{
              px: 4,
              py: 1.4,
              borderRadius: "999px",
              textTransform: "none",
              fontWeight: 500,
              backgroundColor: "#212121", // primary
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#cfac6a", // gold
                color: "#212121",
              },
            }}
          >
            Back to Home
          </Button>

          {/* Contact */}
          <Button
            component={RouterLink}
            to="/contact"
            variant="outlined"
            sx={{
              px: 4,
              py: 1.4,
              borderRadius: "999px",
              textTransform: "none",
              fontWeight: 500,
              borderColor: "#cfac6a", // gold
              color: "#1c1c1c",
              "&:hover": {
                backgroundColor: "rgba(207, 172, 106, 0.12)",
                borderColor: "#cfac6a",
              },
            }}
          >
            Contact Us
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default NotFound;
